export const sendSettledPaymentsSignal = (settledPaymentsCount: number) => {
  window.posthog.setPersonProperties({ synkedupSettledPayments: settledPaymentsCount })
}
